import React from "react"
import ArticlePage from "@Screens/Knowledge/Articles/ArticlesPage"
import { useRecoilValue } from "recoil"
import { allAxisAtom } from "@Recoil/Atom/DiagnosisAtom"
import { AXIS, AXIS_IDENTIFICATION } from "@Constants/constant"
import ContenusByAxis from "@Screens/Knowledge/ContenusByAxis/ContenusByAxis"

const Dietetique = (props) => {
    const { navigation } = props
    const allAxis = useRecoilValue(allAxisAtom)
    const dietetique = allAxis.filter((item) => item.name === AXIS.DIETETIQUE)
    return <ArticlePage navigation={navigation} axisId={dietetique && dietetique.length > 0 ? dietetique[0]?.id : -1} />
    // return <ContenusByAxis axisId={AXIS_IDENTIFICATION.DIET} />
}

export default Dietetique
